export default __webpack_public_path__ + "static/media/AIS-logo.8ed0d5ad.png";